var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("DemoStars"),
      _c("div", [
        _c("h1", {
          staticClass: "text-h5 moinblue--text mb-4",
          domProps: {
            innerHTML: _vm._s(_vm.$t(`demo.${_vm.step}.loading.title`)),
          },
        }),
        _c("div", {
          domProps: {
            innerHTML: _vm._s(_vm.$t(`demo.${_vm.step}.loading.body`)),
          },
        }),
      ]),
      _c("DemoCompanyUrl"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }